import EditResumeWithResumeScore from './EditResumeWithResumeScore'
export default EditResumeWithResumeScore
